export const environment = {
  production: true,
  googleMapsApiKey: 'AIzaSyCL8S0-DXPDDWhj_UkSy6FVbZSD5rKdhjk'
};
